export default "__VITE_ASSET__CDyvjtc9__"